import { render, staticRenderFns } from "./AddComponent.vue?vue&type=template&id=1f2f7b42&scoped=true&"
import script from "./AddComponent.vue?vue&type=script&lang=js&"
export * from "./AddComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddComponent.vue?vue&type=style&index=0&id=1f2f7b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f7b42",
  null
  
)

export default component.exports